module.exports = __webpack_public_path__ + "img/wps-doc.40ff6f6a.png";